import type { ClassValue } from 'clsx';
import classNames from 'clsx';
import { useCallback, useContext } from 'react';

import { ThemeContext } from '../../ThemeProvider/ThemeProvider';

function useFusionTheme() {
  const { theme } = useContext(ThemeContext);

  const addThemeClassName = useCallback(
    (...classNamesArray: ClassValue[]) => classNames(classNamesArray, 'fusion', theme),
    [theme]
  );

  return { theme, addThemeClassName };
}

export default useFusionTheme;
